import React, { FC } from 'react'
import { PrintLayout } from 'components/Layout'
import { MonthlyReportDetailPrintTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { parseToDate } from 'lib/helper'
import format from 'date-fns/format'

const MonthlyReportDetailPrint: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isValidPath = /\/account\/revenue\/monthly_report\/print\/.+/.test(pathname)
  const yearMonth = isValidPath ? pathname.split('/account/revenue/monthly_report/print/')[1] : undefined
  const datetime = yearMonth ? parseToDate(yearMonth + '01') : new Date()
  const headline = `${format(datetime, 'yyyy年M月')}売上レポート`
  return (
    <PrintLayout title={headline}>
      <MonthlyReportDetailPrintTemplate headline={headline} datetime={datetime} yearMonth={yearMonth} />
    </PrintLayout>
  )
}

export default MonthlyReportDetailPrint
